import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Article, ChartLineUp, User, Palette, Plus, Globe, EnvelopeSimple, Books } from "@phosphor-icons/react";

const items = [
  { to: "/dashboard", end: true, label: "Articles", icon: Article, testid: "side-articles" },
  { to: "/dashboard/library", label: "Library", icon: Books, testid: "side-library" },
  { to: "/dashboard/analytics", label: "Analytics", icon: ChartLineUp, testid: "side-analytics" },
  { to: "/dashboard/subscribers", label: "Subscribers", icon: EnvelopeSimple, testid: "side-subscribers" },
  { to: "/dashboard/series", label: "Series", icon: Books, testid: "side-series" },
  { to: "/dashboard/profile", label: "Profile", icon: User, testid: "side-profile" },
  { to: "/dashboard/theme", label: "Theme", icon: Palette, testid: "side-theme" },
  { to: "/dashboard/domain", label: "Domain", icon: Globe, testid: "side-domain" },
];


export default function DashboardLayout() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid grid-cols-12 gap-8">
      <aside className="col-span-12 md:col-span-3 lg:col-span-2">
        <div className="eyebrow text-muted-foreground mb-4">Workspace</div>
        <nav className="flex md:flex-col overflow-x-auto md:overflow-x-visible no-scrollbar border border-border bg-card">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm border-r md:border-r-0 md:border-b border-border last:border-r-0 md:last:border-b-0 whitespace-nowrap ${isActive ? "bg-foreground text-background" : "hover:bg-secondary"}`
              }
              data-testid={it.testid}
            >
              <it.icon size={16} weight="duotone" /> {it.label}
            </NavLink>
          ))}
          <NavLink to="/dashboard/new" className="flex items-center gap-3 px-4 py-3 text-sm bg-secondary hover:bg-foreground hover:text-background border-l md:border-l-0 md:border-t border-border whitespace-nowrap" data-testid="side-new-article">
            <Plus size={16} weight="bold" /> New article
          </NavLink>
        </nav>
      </aside>
      <main className="col-span-12 md:col-span-9 lg:col-span-10">
        <Outlet />
      </main>
    </div>
  );
}
